export const WIDTH_OF_PERIOD = 120;
export const MILLISECONDS_IN_MINUTE = 60000;
export const MILLISECONDS_IN_DAY_HALF = MILLISECONDS_IN_MINUTE * 60 * 12;
export const SCALE_NUMBERS = [1, 3, 6, 12, 24, 48];
export const MIN_SCALE = 1;
export const MAX_SCALE = SCALE_NUMBERS.length;
